// Glow ink (M22-adjacent). PURE (ENG-1). A glow ink sac (a glow squid's drop) makes
// a sign's text glow; a plain ink sac turns the glow back off. These are the pure
// rules the host applies when an ink is used on a sign.

/** Whether `held` is an ink that a sign responds to. */
export function glowInkApplies(held: string): boolean {
  return held === 'glow_ink_sac' || held === 'ink_sac';
}

/** The sign's glow state after `held` is applied to it — glow ink lights it, plain
 *  ink darkens it, anything else leaves it unchanged. */
export function signGlowAfter(current: boolean, held: string): boolean {
  if (held === 'glow_ink_sac') return true;
  if (held === 'ink_sac') return false;
  return current;
}
